// src/features/websites/components/IntroductionParameters.tsx
import React from 'react';
import { Attribution as AttributionIcon } from '@mui/icons-material';
import { Grid, TextField, Typography } from '@mui/material';
import CollapsibleSection from '../../../components/common/CollapsibleSection';

interface IntroductionParametersSectionProps {
  newsAttribution: string;
  sponsor: string;
  premiumUpsellOffer: string;
  isLoading: boolean;
  onChange: (field: 'newsAttribution' | 'sponsor' | 'premiumUpsellOffer', value: string) => void;
  icon?: React.ReactNode;
}

const IntroductionParametersSection: React.FC<IntroductionParametersSectionProps> = ({
  newsAttribution,
  sponsor,
  premiumUpsellOffer,
  isLoading,
  onChange,
  icon = <AttributionIcon sx={{ mr: 1 }} />,
}) => {
  return (
    <CollapsibleSection title="Introduction Parameters" icon={icon}>
      <Typography variant="body2" color="text.secondary" paragraph>
        Specify information used by the host during the introduction.
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="News Attribution"
            value={newsAttribution}
            onChange={(e) => onChange('newsAttribution', e.target.value)}
            disabled={isLoading}
            placeholder="e.g., 'The Kenwood Press, serving the communities of Kenwood, Glen Ellen and Oakmont'"
            helperText="This will be used to attribute news sources in the generated content"
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Sponsor Mention"
            value={sponsor}
            onChange={(e) => onChange('sponsor', e.target.value)}
            disabled={isLoading}
            placeholder="e.g., 'Today’s headlines are brought to you by Acme Coffee'"
            helperText="Optional sponsor message to incorporate in introduction"
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Premium Upsell Offer"
            value={premiumUpsellOffer}
            onChange={(e) => onChange('premiumUpsellOffer', e.target.value)}
            disabled={isLoading}
            placeholder="e.g., 'Subscribe to our premium service for breaking news alerts, in-depth analysis, and ad-free listening'"
            helperText="Optional promotional message for premium services that can be included in audio content"
          />
        </Grid>
      </Grid>
    </CollapsibleSection>
  );
};

export default IntroductionParametersSection;
